<template>
  <b-modal
    id="modal-multi-3"
    size="sm"
    title="CONFIGURACIÓN DE CANCHAS"
    ok-only
    ok-title="Accept"
    v-model="$store.state.someVariables.showModalCanchas"
    no-close-on-backdrop
    @hidden="close"
  >
    <b-row
      v-for="cancha in listCanchas"
      :key="cancha.id_cancha_horario"
      class="mb-1"
    >
      <!-- {{ cancha }} -->
      <span class="span-texto"
        >Deseo asignar la cancha {{ cancha.id_cancha_horario }} a :</span
      >

      <b-col md="10">
        <!-- {{listCanchas}} -->
        <select-item-cancha
          :listCanchasBD="listCanchasBD"
          :cancha="cancha"
        ></select-item-cancha>
      </b-col>
      <b-col md="2"> </b-col>
    </b-row>
    <b-overlay
      :show="showLoading"
      rounded="sm"
      :class="[showLoading ? 'mt-1' : 'mt-0', '']"
    >
      <b-row>
        <b-col md="3">
          <!-- <b-form-checkbox
            v-for="option in listCategorias"
            :key="option.value"
            v-model="categoriasModel"
            :value="option.value"
            name="flavour-3a"
            style="margin: 10px;"
          >
            {{ option.text }}
          </b-form-checkbox> -->
        </b-col>
      </b-row>
    </b-overlay>
    <template #modal-footer>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="outline-primary"
        class="float-right mr-1"
        @click="close"
      >
        Cerrar
      </b-button>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="float-right"
        @click="asignarProgramacion"
      >
        {{ hayValoresDiferenteCero ? 'Actualizar' : 'Guardar' }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal,
  BButton,
  BRow,
  BCol,
  VBTooltip,
  // BFormCheckbox,
  // BFormInput,
  BOverlay,
  // BSpinner,
  // xxx,
  // xxxx,
  // sss,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
// import vSelect from 'vue-select'
// import Cleave from 'vue-cleave-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { computed, ref } from '@vue/composition-api'
import apiCall from '../../utils/apiCall'
import {
  URL,
  USER,
  ROLES,
  //   ESTADO_JUGADOR,
  //   INSERT_DATA_PLAYER,
  //   INSERT_DATA_HISTORY_PLAYER,
  //   UPDATE_DATA_PLAYER,
} from '../../utils/variables'
import SelectItemCancha from './SelectItemCancha.vue'

export default {
  components: {
    BModal,
    BButton,
    // vSelect,
    SelectItemCancha,
    BRow,
    BCol,
    // BFormCheckbox,
    // Cleave,
    // BFormInput,
    BOverlay,
  },

  directives: {
    'b-tooltip': VBTooltip,
    // 'b-popover': VBPopover,
    // heightFade,
    Ripple,
  },
  props: {
    listCategorias: Array,
    showLoading: Boolean,
    listConfiguraciones: Array,
    isCreando: Boolean,
    listDias: Array,
    listCanchas: Array,
    listCanchasBD: Array,
    historialSeleccionado: Object,
  },
  setup(props, { emit }) {
    // console.log(props)
    // const listCategorias = ref([])
    // const listDias = ref([])
    // const categoriasSeleccionadas = ref([])
    const configuracionSelected = ref({
      label: 'Seleccione slots',
      value: null,
    })
    const nombreConfig = ref(null)
    const showMensajeGuardar = ref(false)
    // const isCreando = ref(false)
    const time = ref({
      time: true,
      timePattern: ['h', 'm'],
    })
    const { postApi } = apiCall()
    const hayValoresDiferenteCero = computed(
      () => props.listCanchas?.some(c => Number(c.value) !== 0),
      // eslint-disbale-next-line
    )
    const categoriasModel = computed({
      get() {
        return props.categoriasSeleccionadas
      },
      set(value) {
        emit('updateCategoriasSeleccionadas', value)
      },
    })
    function sacarDatosImportantes() {
      props.listCanchas.forEach(element => {
        if (element.asignacion?.id_cancha) {
          element.id_cancha_real = element.asignacion.id_cancha
        }
      })
    }
    async function guardarInfo() {
      sacarDatosImportantes()
      const data = {
        canchas: props.listCanchas,
        id_historial: props.historialSeleccionado.id_historial,
      }
      // console.log(data)
      const path = 'ApiConfiguration/insertCanchasAsignacion'
      const response = await postApi(URL, path, data)
      if (response.flag === 'no') {
        emit('errorCanchas')
      } else {
        emit('exitoCanchas', props.listCanchas)
      }
      store.commit('someVariables/UPDATE_SHOW_MODAL_CANCHAS', false)

      // console.log(response)
    }
    function close() {
      store.commit('someVariables/UPDATE_SHOW_MODAL_HORARIOS', false)
      if (!props.isCreando) {
        emit('cierraHorario')
        showMensajeGuardar.value = false
        configuracionSelected.value = null
      }
    }
    const validarCanchas = () => {
      const ids = props.listCanchas.map(c => c.asignacion?.id_cancha)

      // console.log(props.listCanchas)

      // 1️⃣ Verificar que todas estén asignadas
      const todasAsignadas = ids.every(id => id !== undefined && id !== null)

      // 2️⃣ Verificar que no haya repetidas
      const sinRepetidas = new Set(ids).size === ids.length

      return {
        todasAsignadas,
        sinRepetidas,
        valido: todasAsignadas && sinRepetidas,
      }
    }
    function changeConfig(item) {
      nombreConfig.value = item.label
      emit('changeConfig', item)
    }
    function getDataHorariosBlank() {
      // console.log(grupoClick)
      nombreConfig.value = null
      emit('getDataHorariosBlank')
      // listCategorias.value = []
      // listDias.value = []
      // props.isCreando = true
      // showLoading.value = true
      // const path = `ApiConfiguration/getUtilsHorarios/${store.getters['someVariables/getTorneoSeleccionado'].id_torneo}`
      // const data = await getApi(URL, path)
      // listCategorias.value = data.categorias
      // listDias.value = data.dias
      // showLoading.value = false
    }
    function asignarProgramacion() {
      const result = validarCanchas()
      let mensaje = ''
      if (!result.todasAsignadas) {
        // console.log('❌ Hay canchas sin asignar')
        mensaje = ' Hay canchas sin asignar. '
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: mensaje,
              icon: 'AlertCircleIcon',
              variant: 'danger',
              solid: true,
            },
          },
          {
            position: 'bottom-center',
            // eslint-disable-next-line
          },
        )
        return
      }

      if (!result.sinRepetidas) {
        // console.log('❌ Hay canchas repetidas')
        mensaje = ' Hay canchas repetidas. '
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: mensaje,
              icon: 'AlertCircleIcon',
              variant: 'danger',
              solid: true,
            },
          },
          {
            position: 'bottom-center',
            // eslint-disable-next-line
          },
        )
        return
      }

      if (result.valido) {
        guardarInfo()
      }
    }

    function salirModoCreacion() {
      configuracionSelected.value = null
      nombreConfig.value = null
      emit('inicializaVariables')
      // listCategorias.value = []
      // listDias.value = []
    }

    return {
      close,
      USER,
      ROLES,
      getDataHorariosBlank,
      time,
      configuracionSelected,
      nombreConfig,
      salirModoCreacion,
      categoriasModel,
      changeConfig,
      showMensajeGuardar,
      asignarProgramacion,
      hayValoresDiferenteCero,
    }
  },
}
</script>
<style scoped>
.cleave-estilo {
  font-size: 11px;
  width: 80%;
}
.cabecera-tabla {
  background: rgb(67 67 67);
  font-size: 13px;
  font-weight: bolder;
  box-decoration-break: clone;
  color: azure;
  padding: 4px;
  border-radius: 2px;
}
.mensaje-guardar {
  background: cornsilk;
  border-radius: 5px;
  margin-top: 5px;
  font-size: 12px;
  padding: 3px;
  font-weight: 400;
}
.span-texto {
  padding: 4px;
  font-size: 13px;
  font-weight: bolder;
  margin-left: 10px;
}
</style>
